import tealium from '../../tealium';
import { registerAnalyticsEventHandler } from '../registry';
import { IDataLayer } from '../../tealium/data_layer';

const defaultData: IDataLayer = {
  event_name: 'product_card_slider',
  event_category: 'product_card_slider',
  event_action: null, // <expand/collapse>
  event_label: null // <Text of clicked item>
};

function trackPdpAccordion(_: string, eventData: IDataLayer = {}) {
  if (eventData?.eventLabel) {
    eventData.event_action = eventData.eventAction;
    eventData.event_label = eventData.eventLabel;
  }
  tealium.evtLink({ ...defaultData, ...eventData });
}

registerAnalyticsEventHandler('pdpAccordion', trackPdpAccordion);
